import React from 'react';

export const TextArea = ({ label, input }) => {
  return (
    <div>
      <label>{label} <span className="required">*</span></label>
      <textarea {...input} cols={50} rows={15} defaultValue={""}></textarea>
    </div>
  );
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/Contact/TextArea.js